import { render, staticRenderFns } from "./FormCategories.vue?vue&type=template&id=6f147a85"
import script from "./FormCategories.vue?vue&type=script&lang=js"
export * from "./FormCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports